import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/cn.js';
import styles from './SegmentedControl.module.css';
/** ARIA APG `radiogroup`/tab-like segmented control (ux.md menus pattern);
 * active segment = surface-2 fill + sh-sm (CLAUDE_DESIGN.md §6.3). */
export function SegmentedControl({ options, value, onChange, label, loading = false, className, }) {
    return (_jsx("div", { role: "radiogroup", "aria-label": label, className: cn(styles['wrapper'], className), children: options.map((option) => {
            const active = option.value === value;
            return (_jsx("button", { type: "button", role: "radio", "aria-checked": active, disabled: option.disabled || loading, className: cn(styles['segment'], active && styles['active'], loading && styles['loading']), onClick: () => onChange(option.value), children: option.label }, option.value));
        }) }));
}
